import React from 'react';

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/games-list.module.scss";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {Link} from "../../link/link";
import {EntityLogo, EntityLogoProps} from "../../logos/entity-logo";
import {Ellipsis} from "../../misc/ellipsis/ellipsis";

export class GameHeaderProps extends BaseProps {
}

export const GameHeader = observer(({game, controller, className, shouldRenderEntityLogo = true}: GameHeaderProps) => {
  const {state} = controller;
  const {device: {isSmallView}, terms, includeSportType} = state;

  const {FM_VS_NEWWEB, FM_AT_NEWWEB} = terms;
  const {linkModel, homeCompetitor, awayCompetitor, domainModel, date, gameLinkModel} = game;
  const vsTitle: String = domainModel.isHomeAwayInverted ? FM_AT_NEWWEB : FM_VS_NEWWEB;

  const containerProps = {
    className: classNames(styles.game_header_container, className, {[styles.small_view]: isSmallView, [styles.partial]: !shouldRenderEntityLogo, [styles.clickable]: !shouldRenderEntityLogo && linkModel}),
    model: gameLinkModel || linkModel,
    routeProps: {
      dataSource: {
        game: {
          apiModel: domainModel.apiModel,
          homeCompetitor: domainModel.homeCompetitor,
          awayCompetitor: domainModel.awayCompetitor,
          sport: domainModel.sport,
          competition: domainModel.competition,
          startTime: domainModel.startTime,
        }
      }
    },
  }

  const entityLogo: EntityLogoProps = {
    className: classNames(styles.entity_logo),
    width: 24,
    height: 24,
  }

  const nameComponentProps = {
    className: classNames(styles.competitor_name),
  };

  return <Link {...containerProps}>
    {
      shouldRenderEntityLogo ? <EntityLogo {...entityLogo} entity={homeCompetitor}/> : null
    }
    <Ellipsis {...nameComponentProps} text={homeCompetitor.shortName || homeCompetitor.name}/>
    <div className={classNames(styles.competition_separator)}>{vsTitle}</div>
    {
      shouldRenderEntityLogo ? <EntityLogo {...entityLogo} entity={awayCompetitor}/> : null
    }
    <Ellipsis {...nameComponentProps} text={awayCompetitor.shortName || awayCompetitor.name}/>
    {
      shouldRenderEntityLogo ? <div className={classNames(styles.header_date)}>{`${date}${includeSportType ? ` | ${game.domainModel.sport.name}` : ''}`}</div> : null
    }
  </Link>
});

